import $ from 'jquery';
import 'slick-carousel';

$( document ).ready( () => {
    if( !$( '.hero-calendar__slider-slides' ).length ) {
        return;
    }

    $( '.hero-calendar__slider-slides' ).slick( {
        appendArrows: '.hero-calendar__slider-buttons',
        appendDots: '.hero-calendar__featured-text-dots',
        dots: true,
        prevArrow: '<button class="hero-calendar__button"><i class="icon-arrow-left"/><span class="hero-calendar__button-text">Previous Slide</span></button>',
        nextArrow: '<button class="hero-calendar__button"><i class="icon-arrow-right"/><span class="hero-calendar__button-text">Next Slide</span></button>',
        asNavFor: '.hero-calendar__control-slider',
        fade: true,
        autoplay: true,
    } );

    $( '.hero-calendar__control-slider' ).slick( {
        slidesToShow: 1,
        fade: true,
        arrows: false,
    } );

    $( '.hero-calendar__next-slider-thumb-inner' ).on( 'click', function() {
        $( '.hero-calendar__slider-slides' ).slick(
            'slickGoTo',
            $( this ).attr( 'data-num' ),
        );
    } );

    const $hero = $( '.hero-calendar' );

    $hero.css( {
        maxHeight: $hero
            .find( '.hero-calendar__inner' )
            .first()
            .outerHeight( true ),
    } );

    $hero.one( 'transitionend', () => {
        $hero.removeClass( 'hero-calendar--loading' );
        $hero.one( 'transitionend', () => $hero.css( { maxHeight: '' } ) );
    } );
} );
